
import subjectDefaultData from "Pub/js/subjectDefaultData";
import backgroundImg1 from 'Assets/images/backgroundImg/backgroundImg1.jpg';
import backgroundImg2 from 'Assets/images/backgroundImg/backgroundImg2.jpg';
import backgroundImg3 from 'Assets/images/backgroundImg/backgroundImg3.jpg';
import backgroundImg4 from 'Assets/images/backgroundImg/backgroundImg4.jpg';
import backgroundImg5 from 'Assets/images/backgroundImg/backgroundImg5.jpg';
import defaultBgImg from "Assets/images/light-final-bg2.jpg";
import backgroundImg from "Assets/images/backgroundImg/backgroundImg.png";

// 部件背景图
import bg1 from "Assets/images/widget_bg/bg1.png";
import bg2 from "Assets/images/widget_bg/bg2.png";
import bg3 from "Assets/images/widget_bg/bg3.png";
import bg4 from "Assets/images/widget_bg/bg4.png";
import bg5 from "Assets/images/widget_bg/bg5.png";
import blackBg1 from "Assets/images/widget_bg/black_bg1.png";
import blackBg2 from "Assets/images/widget_bg/black_bg2.png";
import blackBg3 from "Assets/images/widget_bg/black_bg3.png";
import blackBg4 from "Assets/images/widget_bg/black_bg4.png";
import blackBg5 from "Assets/images/widget_bg/black_bg5.png";

// 应用背景图
// 数据类
import appBgData1 from "Assets/images/app_bg/data_1.png";
import appBgData2 from "Assets/images/app_bg/data_2.png";
import appBgData3 from "Assets/images/app_bg/data_3.png";
import appBgData4 from "Assets/images/app_bg/data_4.png";
import appBgData5 from "Assets/images/app_bg/data_5.png";
import appBgData6 from "Assets/images/app_bg/data_6.png";
import appBgData7 from "Assets/images/app_bg/data_7.png";
import appBgData8 from "Assets/images/app_bg/data_8.png";
import appBgData9 from "Assets/images/app_bg/data_9.png";
import appBgData10 from "Assets/images/app_bg/data_10.png";
import appBgData11 from "Assets/images/app_bg/data_11.png";
import appBgData12 from "Assets/images/app_bg/data_12.png";
// 业务类
import appBgSetting1 from "Assets/images/app_bg/setting_1.png";
import appBgSetting2 from "Assets/images/app_bg/setting_2.png";
import appBgSetting3 from "Assets/images/app_bg/setting_3.png";
import appBgSetting4 from "Assets/images/app_bg/setting_4.png";
import appBgSetting5 from "Assets/images/app_bg/setting_5.png";
import appBgSetting6 from "Assets/images/app_bg/setting_6.png";
import appBgSetting7 from "Assets/images/app_bg/setting_7.png";
import appBgSetting8 from "Assets/images/app_bg/setting_8.png";
import appBgSetting9 from "Assets/images/app_bg/setting_9.png";
import appBgSetting10 from "Assets/images/app_bg/setting_10.png";
import appBgSetting11 from "Assets/images/app_bg/setting_11.png";
import appBgSetting12 from "Assets/images/app_bg/setting_12.png";

const imgObj = {
    backgroundImg1,
    backgroundImg2,
    backgroundImg3,
    backgroundImg4,
    backgroundImg5,
};

export const getBackgroundStyle = (backgroundObject, colorName) => {
    let bgStyle = {};
    if (backgroundObject) {
        const { bdtype, bgColor, bgImg, blurNumber } = backgroundObject;
        if (bdtype === 'pic') {
            const bgUrl = bgImg.includes('base64') ? bgImg : imgObj[bgImg] || defaultBgImg;
            bgStyle = {
                background: `url(${bgUrl}) no-repeat center center / 100% 100%`,
                filter: `blur(${blurNumber}px)`,
                transform: 'scale(1.2)',
            };
        } else if (bdtype === 'color') {
            if (colorName === 'black' && bgColor === "gray") { // 暗黑并且颜色背景的第一个
                bgStyle = {};
            } else {
                bgStyle = { backgroundColor: subjectDefaultData.bgColorMap[bgColor] || bgColor };
                if (colorName !== 'black') { // 非暗黑主题加背景图
                    bgStyle = {
                        ...bgStyle,
                        backgroundImage: `url(${backgroundImg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundSize: '100% 100%',
                    };
                }
            }
        }
        if (colorName === 'black') { // 判断当前选中主题是暗黑
            bgStyle = {
                opacity: 0.3,
                ...bgStyle,
            };
        }
    }
    return bgStyle;
};

const DefaultWidgetBgs = [
    { key: 'img-1', src: bg1 },
    { key: 'img-2', src: bg2 },
    { key: 'img-3', src: bg3 },
    { key: 'img-4', src: bg4 },
    { key: 'img-5', src: bg5 },
];
const BlackWidgetBgs = [
    { key: 'img-1', src: blackBg1 },
    { key: 'img-2', src: blackBg2 },
    { key: 'img-3', src: blackBg3 },
    { key: 'img-4', src: blackBg4 },
    { key: 'img-5', src: blackBg5 },
];
export const getWidgetBgImgs = themeType => {
    return [...(themeType === 'black' ? BlackWidgetBgs : DefaultWidgetBgs), { key: 'custom' }];
};
export const getCurrentBgImg = (imgKey, themeType) => {
    if (!imgKey) {return;}

    const widgetBgs = themeType === 'black' ? BlackWidgetBgs : DefaultWidgetBgs;
    const currentBg = widgetBgs.find(bg => bg.key === imgKey);
    return currentBg && currentBg.src;
};


export const AppDataBgs = [
    { key: 'img-data-1', src: appBgData1 },
    { key: 'img-data-2', src: appBgData2 },
    { key: 'img-data-3', src: appBgData3 },
    { key: 'img-data-4', src: appBgData4 },
    { key: 'img-data-5', src: appBgData5 },
    { key: 'img-data-6', src: appBgData6 },
    { key: 'img-data-7', src: appBgData7 },
    { key: 'img-data-8', src: appBgData8 },
    { key: 'img-data-9', src: appBgData9 },
    { key: 'img-data-10', src: appBgData10 },
    { key: 'img-data-11', src: appBgData11 },
    { key: 'img-data-12', src: appBgData12 },
];
export const AppSettingBgs = [
    { key: 'img-setting-1', src: appBgSetting1 },
    { key: 'img-setting-2', src: appBgSetting2 },
    { key: 'img-setting-3', src: appBgSetting3 },
    { key: 'img-setting-4', src: appBgSetting4 },
    { key: 'img-setting-5', src: appBgSetting5 },
    { key: 'img-setting-6', src: appBgSetting6 },
    { key: 'img-setting-7', src: appBgSetting7 },
    { key: 'img-setting-8', src: appBgSetting8 },
    { key: 'img-setting-9', src: appBgSetting9 },
    { key: 'img-setting-10', src: appBgSetting10 },
    { key: 'img-setting-11', src: appBgSetting11 },
    { key: 'img-setting-12', src: appBgSetting12 },
]

export const getCurrentAppBg = (imgKey, themeType) => {
    if (!imgKey) {return;}

    const currentBg = [...AppDataBgs, ...AppSettingBgs].find(bg => bg.key === imgKey);
    return currentBg && currentBg.src;
}

export default { ...imgObj };
